import clsx from 'clsx';

import styles from './ComparatorRenderer.module.scss';

export default function ComparatorRenderer({
  comparator,
  className,
}: {
  comparator: string;
  className?: string;
}) {
  return (
    <div className={clsx(styles.comparator, className)}>
      {comparator}
    </div>
  );
}
